import React from 'react';
import { ShieldCheck, Heart, Leaf } from 'lucide-react';

const About = () => {
  return (
    <div className="container py-16" data-testid="about-page">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="about-title">
            אודותינו
          </h1>
          <p className="text-base md:text-lg text-stone-600">
            האתר המוביל בישראל לבריאות הגבר
          </p>
        </div>
        
        {/* Hero Image */}
        <div className="rounded-2xl overflow-hidden mb-12 shadow-xl">
          <img
            src="https://images.unsplash.com/photo-1651993382466-0fefd887e901?crop=entropy&cs=srgb&fm=jpg&q=85"
            alt="אודותינו"
            className="w-full h-80 object-cover"
          />
        </div>
        
        {/* Story */}
        <div className="bg-white rounded-2xl p-8 md:p-12 border border-stone-100 mb-12" data-testid="about-story">
          <h2 className="text-3xl font-bold text-[#2C3E2D] mb-6" style={{ fontFamily: 'Heebo, sans-serif' }}>
            הסיפור שלנו
          </h2>
          <div className="space-y-4 text-stone-600 leading-relaxed">
            <p>
              בריאות הגבר נוסדה מתוך הבנה שבריאות הגבר היא נושא חשוב שרבים מהססים לדבר עליו. אנו כאן כדי לספק פתרונות איכותיים ומידע מקצועי בצורה דיסקרטית ומכבדת.
            </p>
            <p>
              המוצרים שלנו נבחרו בקפידה על ידי צוות מומחים בתחום הבריאות, ועוברים ביקורת איכות מקיפה לפני שהם מוצעים ללקוחותינו. אנו מאמינים בגישה טבעית ומקיפה לבריאות.
            </p>
            <p>
              המטרה שלנו היא להפוך את המידע והמוצרים האיכותיים ביותר לזמינים לכל גבר בישראל, תוך שמירה על פרטיות מלאה ושירות מקצועי.
            </p>
          </div>
        </div>
        
        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-testid="about-values">
          <div className="bg-[#F5F5F4] p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-[#D97706]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <ShieldCheck className="w-8 h-8 text-[#D97706]" />
            </div>
            <h3 className="text-xl font-semibold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
              איכות בלתי מתפשרת
            </h3>
            <p className="text-stone-600">
              כל מוצר עובר ביקורת איכות מקיפה
            </p>
          </div>
          
          <div className="bg-[#F5F5F4] p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-[#D97706]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Heart className="w-8 h-8 text-[#D97706]" />
            </div>
            <h3 className="text-xl font-semibold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
              גישה אישית
            </h3>
            <p className="text-stone-600">
              שירות אישי ומכבד לכל לקוח
            </p>
          </div>
          
          <div className="bg-[#F5F5F4] p-8 rounded-2xl text-center">
            <div className="w-16 h-16 bg-[#D97706]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Leaf className="w-8 h-8 text-[#D97706]" />
            </div>
            <h3 className="text-xl font-semibold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
              גישה טבעית
            </h3>
            <p className="text-stone-600">
              מוצרים טבעיים ובטוחים
            </p>
          </div>
        </div>
        
        {/* Contact */}
        <div className="bg-[#2C3E2D] text-white rounded-2xl p-12 text-center" data-testid="about-contact">
          <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
            צריכים עזרה?
          </h2>
          <p className="text-stone-300 mb-8">
            הצוות שלנו כאן כדי לעזור לך. צור איתנו קשר בכל עת
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/972539406051?text=היי,+הגעתי+דרך+האתר+ואשמח+למידע+נוסף"
              target="_blank"
              rel="noopener noreferrer"
              className="h-12 px-8 rounded-full bg-[#D97706] text-white font-bold hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center"
              style={{ fontFamily: 'Heebo, sans-serif' }}
            >
              לחץ למידע עם נציג
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;